/**
 * Homepage marquee media - photo paths + YouTube film IDs.
 * Photos use lightweight /albums/marquee/ thumbs (not full portfolio masters).
 * Keep couple folders in sync with Photos.js; film IDs with Films.js.
 */

const PORTFOLIO_FOLDERS = [
  'ushing-makhyai',
  'mongting-umeeya',
  'param-fullara',
  'prayas-nova',
  'sujan-priya',
  'ukhingmong-nyomay',
  'hlahlawang-maysingaung',
];

const PHOTO_FILES = [
  'photo1.webp',
  'photo2.webp',
  'photo3.webp',
  'photo4.webp',
  'photo5.webp',
  'photo6.webp',
];

/**
 * Marquee stills - 480px WebP thumbs (~30–80KB each).
 * Full masters under /albums/portfoliophotos average ~1.5MB and cause scroll jank.
 */
export const HOME_PHOTO_PATHS = PORTFOLIO_FOLDERS.flatMap((folder) =>
  PHOTO_FILES.map((file) => `/albums/marquee/portfoliophotos/${folder}/${file}`)
);

/**
 * All Films-page YouTube IDs (new + base), newest first.
 * Thumbnails: https://img.youtube.com/vi/{id}/mqdefault.jpg (lighter than hq)
 */
export const HOME_FILM_IDS = [
  'VE_f7h7WJQs',
  'QlO57RLbbZw',
  'M_EORktSp00',
  'zwvU_9WO9cU',
  'QWQNLxKYOG4',
  'kAks8u7bXAM',
  'LQaW-1JJp1o',
  'lwByx6PceOg',
  'J0YA15QLLR4',
  'LL6eX6ouCR8',
  'FQqYH5cwH6o',
  'V-mFD5srddY',
  '8tXv1yKNHq4',
  'Ocsj8wQZ0Cc',
  'sq36kmXp6a4',
  'Ajcmoq9kHX8',
  'SWELRR1mmJ4',
  'rC8eUtiNhsw',
  'WSRd5pBrHrY',
  '3_4idzYbCuI',
  'xpIeHgPz_iU',
  'Mi-UuxVIDE4',
];

/**
 * Distribute unique items across `rowCount` rows (round-robin).
 * Never places the same item twice in one row.
 */
export function chunkIntoRows(items, rowCount = 5) {
  if (!items.length || rowCount < 1) return [];

  const rows = Array.from({ length: rowCount }, () => []);
  const seen = Array.from({ length: rowCount }, () => new Set());

  items.forEach((item, index) => {
    const rowIndex = index % rowCount;
    if (seen[rowIndex].has(item)) return;
    seen[rowIndex].add(item);
    rows[rowIndex].push(item);
  });

  return rows.filter((row) => row.length > 0);
}

export function getHomePhotoRows(rowCount = 5) {
  return chunkIntoRows(HOME_PHOTO_PATHS, rowCount);
}

export function getHomeFilmRows(rowCount = 5) {
  return chunkIntoRows(HOME_FILM_IDS, rowCount);
}

export function youtubeThumbUrl(videoId) {
  return `https://img.youtube.com/vi/${videoId}/mqdefault.jpg`;
}
